import { render, staticRenderFns } from "./SearchPane.vue?vue&type=template&id=6cb54391&scoped=true&"
import script from "./SearchPane.vue?vue&type=script&lang=js&"
export * from "./SearchPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb54391",
  null
  
)

export default component.exports